import {
  getCountryCode,
  getRegionList,
  getDistrictList,
  getMunicipalityList
} from './regionHelper';

/**
 * Generates a registration number string using selections from dropdowns.
 * Includes SMMEs code if present in selections (single or multi-select).
 * @param {object} selections - User selections (COUNTRY, REGION, DISTRICT, MUNICIPALITY, SMMEs, user_type).
 * @param {string} currentDateTime
 * @param {string} userLogin
 * @returns {string} registration number
 */
export const generateRegistrationNumber = (selections, currentDateTime, userLogin) => {
  const prefix = "FN";
  const countryCode = getCountryCode(selections.COUNTRY?.name || selections.COUNTRY);

  // Region code
  let regionCode = "00";
  if (selections.REGION && selections.REGION !== "--") {
    const regionName = selections.REGION.name || selections.REGION;
    const regionList = getRegionList(countryCode);
    const region = regionList.find(r => 
      r.name.trim() === regionName.trim() || 
      r.value.toString() === regionName.trim()
    );
    if (region) {
      // Convert value to string, remove any non-digit characters, and pad with leading zeros
      regionCode = region.value.toString().replace(/\D/g, '').padStart(2, '0');
    }
  }

  // District/Municipality code
  let districtCode = "000";
  if (selections.DISTRICT && selections.DISTRICT !== "--") {
    const districtName = selections.DISTRICT.name || selections.DISTRICT;
    const districtList = getDistrictList(countryCode);
    const district = districtList && districtList.find(m => 
      m.name.trim() === districtName.trim() || 
      m.value.toString() === districtName.trim()
    );
    if (district) {
      // Convert value to string, remove any non-digit characters, and pad with leading zeros
      districtCode = district.value.toString().replace(/\D/g, '').padStart(3, '0');
    }
  }

  // Get user type code from parentheses in the selection
  let userTypeCode = "---";
  if (selections["USER TYPE"] && selections["USER TYPE"] !== "View more") {
    const userType = selections["USER TYPE"];
    // Extract the code from parentheses using regex
    const codeMatch = userType.match(/\(([^)]+)\)/);
    if (codeMatch && codeMatch[1]) {
      userTypeCode = codeMatch[1];
    }
  }

  // SMMEs code - handle both object and string cases
  let smmesCode = "--";
  if (selections.SMMEs) {
    if (typeof selections.SMMEs === 'object' && selections.SMMEs.value) {
      smmesCode = selections.SMMEs.value;
    } else if (typeof selections.SMMEs === 'string') {
      smmesCode = selections.SMMEs;
    }
  }

  // Random 6-digit number
  const randomNum = Math.floor(100000 + Math.random() * 900000).toString();

  // Combine all parts
  const fullNumber = `${prefix}${countryCode}${regionCode}${districtCode}${userTypeCode}${randomNum}`;

  console.log("Generated registration number components:", {
    prefix,
    countryCode,
    regionCode,
    districtCode,
    userTypeCode,
    randomNum,
    fullNumber
  });

  return fullNumber;
};